
<p *ngIf="custom_code==undefined" [ngStyle]="data.eleStyle">{{data.message}}&nbsp;<a [href]="data.url" target="_blank">{{data.url_text}}</a></p> 
<div  *ngIf="custom_code!=undefined"  [innerHTML]="custom_code | sanitizeHtml"></div>
<button [ngStyle]="data.btnStyle" [mat-dialog-close]="" >{{data.btnText}}</button> 

 